import { media } from "@microsoft/teams-js";
import { useCallback } from "react";

import { usePlatform } from "../features/platform-detection/use-platform.js";
import { useDevicesStore } from "../features/table-call/audio-devices.store.js";

// ? This is work in progress hook, that ideally should handle all audio related logic.
// ? For now, it's only used for getting the audio permissions.
// ? Once you have the time, please update deviceSettings with it, so we can simplify the code.
export const useAudio = () => {
  const { isTeamsWebClient } = usePlatform();
  const { setHasPermissions } = useDevicesStore();

  const testAudioPermissions = useCallback(async () => {
    let browserPermissions = false;
    let teamsPermissions = false;

    try {
      // If we are in teams web, we also need to ask for Teams permissions
      if (isTeamsWebClient()) {
        teamsPermissions = await media.hasPermission();
      }
    } catch {
      // Teams permission access is optional outside the Teams web client.
    }

    try {
      // This tests the browser's permission to use the microphone
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      browserPermissions = true;
      for (const track of stream.getTracks()) {
        track.stop();
      }
    } catch {
      // Browser permission prompts can be declined by the user.
    }

    // Ensure we have the permissions in the store
    setHasPermissions(
      browserPermissions && (isTeamsWebClient() ? teamsPermissions : true)
    );

    return {
      browserPermissions,
      teamsPermissions,
    };
  }, [isTeamsWebClient, setHasPermissions]);

  // const updateAvailableDevices = async () => {
  //   const devices = await navigator.mediaDevices.enumerateDevices();

  //   setAvailableMicrophones(devices.filter((d) => d.kind === "audioinput"));
  //   setAvailableSpeakers(devices.filter((d) => d.kind === "audiooutput"));
  //   setAvailableDevices(devices);
  // };

  // const setDefaultDeviceIfEmpty = () => {
  //   updateAvailableDevices();

  //   if (!microphone && availableMicrophones.length > 0) {
  //     // ! In firefox, the default microphone is the first one
  //     const defaultMicrophone =
  //       availableMicrophones.find((mic) => mic.deviceId === "default") ||
  //       availableMicrophones[0];
  //     if (defaultMicrophone) {
  //       setMicrophone(defaultMicrophone);
  //     }
  //   }

  //   if (!speaker && availableSpeakers.length > 0) {
  //     // ! In firefox, the default speaker is the first one
  //     const defaultSpeaker =
  //       availableSpeakers.find((speaker) => speaker.deviceId === "default") ||
  //       availableSpeakers[0];
  //     if (defaultSpeaker) {
  //       setSpeaker(defaultSpeaker);
  //     }
  //   }
  // };

  // const getDeviceStreamById = async (id) => {
  //   updateAvailableDevices();

  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({
  //       audio: {
  //         deviceId: { exact: id },
  //         echoCancellation: true,
  //         noiseSuppression: true,
  //         autoGainControl: true,
  //       },
  //     });

  //     return stream;
  //   } catch (error) {
  //     console.error(`Failed to get device stream by id: ${id}`, error);
  //   }

  //   return null;
  // };

  return {
    testAudioPermissions,
    // updateAvailableDevices,
    // setDefaultDeviceIfEmpty,
    // getDeviceStreamById,
  };
};
